module.exports = __webpack_public_path__ + "static/img/publicSecurityIcon.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/publicSecurityIcon.png
// module id = 2Kwe
// module chunks = 2